import { Ring } from "@uiball/loaders";

import { colors, strCode } from "../../../../consts";
import { t } from "../../../../services";

import { FlexContainers, WrapperContainer } from "../../../../components";
import { LoaderText } from "./styled";

export const Loader = () => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnCenter}
      gap={16}
      width={"100%"}
      height={"100%"}>
      <Ring color={colors.RAISIN_50} size={48} lineWeight={4} speed={2} />
      <LoaderText>{t(strCode.LOADING_PLEASE_WAIT_TITLE)}</LoaderText>
    </WrapperContainer>
  );
};
